<template>
    <div class="w-full lg:w-1/2 md:w-full shadow-lg rounded-lg overflow-hidden">
        <div class="py-3 px-5 bg-gray-50"> {{ this.title }}


            <Pie
                id="pieChat"
                :options="chartOptions"
                :data="chartData"

            />
        </div>
    </div>
</template>
<script>
import {Pie} from 'vue-chartjs'
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
    name: 'PieChart',
    components: {Pie},
    props: {
        projectData: Array,
        title: String
    },
    data() {

        const lables = this.projectData.flat().map(obj => obj.name);
        const data = this.projectData.flat().map(obj => obj.data);
        const colors = this.projectData.flat().map(obj => obj.color);

        return {

            chartData: {
                labels: lables,
                datasets: [
                    {
                        label: this.title,
                        backgroundColor: colors,
                        data: data,
                    }
                ]
            },
            chartOptions: {
                responsive: true
            }
        }
    },
}
</script>
